import type { VodOrigin } from '../types/vod'

/**
 * How an asset's backend-classified origin renders as a badge.
 *
 * Shared because the list and the detail page both draw it, and they used to
 * hold divergent copies: one fell back to the raw code for an unrecognized
 * origin, the other to "Unknown", and adding a facet meant editing both. The
 * API classifies origin server-side, so a bundle can always meet a value it
 * predates — an editor's SPA tab outlives a deploy — which is why the accessors
 * below never index these maps raw.
 */
export const ORIGIN_LABEL: Record<VodOrigin, string> = {
  AMAGI: 'Amagi',
  WSC: 'WSC',
  PDM: 'PDM',
  TENNIS_CHANNEL: 'Tennis Channel',
  VIRTUAL: 'Virtual',
  UNKNOWN: 'Unknown',
}

export const ORIGIN_VARIANT: Record<
  VodOrigin,
  'primary' | 'secondary' | 'neutral'
> = {
  AMAGI: 'secondary',
  WSC: 'secondary',
  PDM: 'secondary',
  TENNIS_CHANNEL: 'primary',
  VIRTUAL: 'neutral',
  UNKNOWN: 'neutral',
}

export const originLabel = (origin?: VodOrigin): string =>
  (origin && ORIGIN_LABEL[origin]) || ORIGIN_LABEL.UNKNOWN

export const originVariant = (
  origin?: VodOrigin
): 'primary' | 'secondary' | 'neutral' =>
  (origin && ORIGIN_VARIANT[origin]) || ORIGIN_VARIANT.UNKNOWN

/** True when the badge fell back, so a caller can add the raw vendor for context. */
export const isUnrecognizedOrigin = (origin?: VodOrigin): boolean =>
  originLabel(origin) === ORIGIN_LABEL.UNKNOWN
